var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextBlock',_vm._b({},'TextBlock',Object.assign({}, {tag: 'h4',
    size: 1.125,
    lineHeight: 1.5},
    _vm.textBlockProps),false),[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }